import { useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { logoutUser } from '../utils/jwtUtils';

/** Returns an async handler that ends the session server-side, clears local auth and goes to /login. */
const useLogout = () => {
	const { actions: { logOut } } = useContext(AuthContext);
	const navigate = useNavigate();

	return useCallback(async () => {
		try {
			await logoutUser();
		} finally {
			logOut();
			navigate('/login');
		}
	}, [logOut, navigate]);
};

export default useLogout;
